import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import Cookies from "js-cookie"
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const ParentStudentList = () => {
  
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const navigate = useNavigate()

  // Dummy student data
  const [students, setStudents] = useState([]);

  
  useEffect(()=>{
    
    const fetchData = async ()=>{
     try {
       const userCookie = Cookies.get("user")
       if(!userCookie){
        navigate("/Login")
        return
       }

       const parsedUser = JSON.parse(userCookie)
       const token = parsedUser?.token
      console.log("TOKEN:", token)
      const response = await axios.get(BASE_URL+"/parents/students",{
        headers:{
          "Authorization":`Bearer ${token}`
        }
      })
      console.log(response)
      setStudents(response.data.data)
     } catch (error) {
        console.log(error.response?.data?.message)
     }
    }
    fetchData()
  },[])

  const handleView = (id) => {
    if (!id) {
      console.error('Student ID is undefined')
      return
    }
    console.log('Navigate to : ', `/Student/Profile/${id}`)
    navigate(`/Student/Profile/${id}`)
  }


  return (
    <div style={{ marginLeft }}>
        {/* Header */}

        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2>Students</h2>
          </div>
          </div>
         <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0 mt-5">
          <Thead className="bg-dark text-white">
            <Tr className="bg-secondary rounded">
              <Th>#</Th>
              <Th>Name</Th>
              <Th>Email</Th>
              {/* <Th>Course</Th> */}
              {/* <Th>Status</Th> */}
              <Th className="text-center">Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {students.length > 0 ? (
              students.map((student, index) => (
                <Tr key={student.id}>
                  <Td>{index + 1}</Td>
                  <Td>{student.name}</Td>
                  <Td>{student.email}</Td>
                  {/* <Td>{student.course}</Td> */}
                  {/* <Td>
                    <span
                      className={`badge ${
                        student.status === 'Active' ? 'bg-success' : 'bg-secondary'
                      }`}
                    >
                      {student.status}
                    </span>
                  </Td> */}
                  <Td className="text-center">
                    <button
                      className="btn btn-sm btn-info text-white me-2"
                      // onClick={() => navigate("/Student/Profile")}
                      onClick={() => handleView(student.id)}

                    >
                      View
                    </button>
                   </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan="6" className="text-center">
                  No students available
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
 
     
    </div>
  );
};

export default ParentStudentList;
